module.exports = __webpack_public_path__ + "img/sms.6ca22bc9.svg";